import { ReactNode } from "react";

/**
 * <tbody> wrapper. Renders the empty-state row (spanning all columns) when
 * `isEmpty`, otherwise the row children.
 */
export const TableBody = ({
  children,
  colSpan,
  isEmpty,
  empty,
}: {
  children: ReactNode;
  colSpan: number;
  isEmpty?: boolean;
  empty?: ReactNode;
}) => (
  <tbody className="bg-white divide-y divide-gray-200">
    {isEmpty ? (
      <tr>
        <td colSpan={colSpan} className="px-6 py-12 text-center">
          {empty}
        </td>
      </tr>
    ) : (
      children
    )}
  </tbody>
);

export default TableBody;
